export const HELP_TEXT =
  "Chỉ nhận xls, xlsx, ppt, pptx, doc, docx, jpg, jpeg, png, gif. Tổng dung lượng tối đa 100MB.";

export const HELP_TEXT_PDF = "Chỉ nhận file PDF.";

export const ERROR_TEXT_TYPE =
  "Định dạng file không đúng. Chỉ nhận file xls, xlsx, ppt, pptx, doc, docx, jpg, jpeg, png, gif.";

export const ERROR_TEXT_SIZE = "Dung lượng tối đa: 100MB";

export const MAX_FILES = 15000;

export const ACCEPT_FILES = ".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx";

export const ACCEPT_FILES_IMAGE = ".png,.jpg,.jpeg,.eps,.tiff,.gif,.pdf,.bmp,.svg";

export const ACCEPT_FILES_AUDIO = ".mp3,.wav,.flac,.wma,.aac,.ogg,.aiff,.alac";

export const ACCEPT_FILES_PDF = ".pdf";

export const ERROR_TEXT_TYPE_PDF =
  "Định dạng file không đúng. Chỉ nhận file .pdf.";

export const MAX_SIZE = "100MB";

export const EMPTY_FILE_TEXT = "Không có file đính kèm nào";

export const LOI_UPLOAD_QUA_KICH_THUOC = "Tổng dung lượng file tối đa: 100MB";

export const EXPORT_ERROR_TEXT_TYPE =
  "Định dạng file không đúng. Chỉ nhận file xlsx.";

export const EXPORT_ACCEPT_FILES = ".xlsx";
export const FILE_FIELDS = "";
